import { IQuestionAnswer } from "@ninjacart/nc-nk-core";

export const canShowQuestionTimer = (item: IQuestionAnswer) => {
  const isLessThanTenMinsAgo = isLessThanTenMinutesAgo(item?.timestamp) > -1;
  const hasExpertAnswer = item?.children?.find((x) => x.creatorRole === 'mods');
  return isLessThanTenMinsAgo && !hasExpertAnswer;
};
export function isLessThanTenMinutesAgo(createdAt: number): number {
  // Get the current time in milliseconds
  let currentTimeInMillis = new Date().getTime();

  // Calculate the difference in milliseconds
  let differenceInMillis = currentTimeInMillis - createdAt;

  // Convert difference to minutes
  let differenceInMinutes = Math.floor(differenceInMillis / (1000 * 60));

  // Check if the difference is less than 10 minutes
  if (differenceInMinutes < 10) {
    return differenceInMinutes;
  } else {
    return -1;
  }
}